import { BackgroundColors } from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    root: {
      display: 'block',
      backgroundColor: BackgroundColors.base,
    },
    headerBg: {
      '&&': {
        backgroundSize: 'cover',
        paddingTop: Spacings.s8,
        position: 'relative',
        '&:after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: 60,
          background: 'linear-gradient(rgba(255, 255, 255, 0), rgb(255 255 255));',
        },
        '@media screen and (max-width: 768px)': {
          paddingTop: Spacings.s12,
        },
      },
    },
    searchInput: {
      '& form': {
        width: '100%',
      },
    },
    bannerContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: [Spacings.s0, Spacings.s24],
      marginTop: Spacings.s12,
      fontSize: FontSizes.s30,
      position: 'relative',
      zIndex: 999,
      marginBottom: Spacings.s32,
      '@media screen and (max-width: 768px)': {
        padding: [Spacings.s0, Spacings.s12],
      },
      '& > div': {
        maxWidth: 712,
        width: '100%',
        marginBottom: Spacings.s16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: Spacings.s6,
        '@media screen and (max-width: 768px)': {
          marginBottom: Spacings.s16,
        },
      },
      '& h2': {
        fontSize: FontSizes.s30,
      },
    },
    filters: {
      position: 'relative',
      zIndex: 9,
      marginTop: Spacings.s24,
      display: 'flex',
      gap: Spacings.s8,
      '@media screen and (max-width: 768px)': {
        marginTop: Spacings.s0,
      },
    },
  },
  {
    name: 'sizes',
  },
);

export default useStyles;
